import {
  StudioCta,
  StudioCtaProps,
  useSelectButton,
} from '@wix/package-picker-shared-studio';
import React from 'react';

interface SelectButtonProps extends Omit<StudioCtaProps, 'onClick' | 'as'> {
  productId: string;
  source: 'cards' | 'table';
}

export const SelectButton = ({
  productId,
  size = 'small',
  source,
  ...props
}: SelectButtonProps) => {
  const { text, onClick, isDisabled, disabledTooltipContent } = useSelectButton(
    { productId, source },
  );

  return (
    <StudioCta
      onClick={() => onClick()}
      size={size}
      {...props}
      disabled={isDisabled}
      disabledTooltipContent={disabledTooltipContent}
    >
      {text}
    </StudioCta>
  );
};
